/* eslint-disable */
import { http, httpgst } from '../../main'
import { store } from '../../store'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async deleteRequest({ commit }, payload) {
    try {
      const id = payload.event.id
      const url = `api/expenses-items-back/${id}`
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }

      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.delete(url, {}, options)
      const message = response.data.message
      payload.event.context.showNotification(message, 'success')
    } catch (error) {
      console.log(error)
      const message = error.response.data.message
      payload.event.context.showNotification(message, 'error', -1)
    } finally {
      payload.event.context.refresh()
      payload.event.context.dialogDelete = false
    }
  },
  get_items({ commit, dispatch }, payload) {
    let url = 'api/expenses-items-rejected/for-user/' + payload.event.user.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('itemsGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  get_userlogged({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options).then(
      response => {
        commit('userLogged', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategories({ commit, dispatch }, payload) {
    let url = 'api/categories'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategories', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  post({ commit, dispatch }, payload) {
    let typeExpense = payload.event.item.has_advance
    
    let url = 'api/expenses'
    let params = {
      user_id: payload.event.user.id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: 1,
      gst_expenses_status_id: 1,
      petty_cash_type: typeExpense === 'pettyCash' ? 1 : typeExpense === 'amexCard' ? 2 : 0,
    }
    if (payload.event.item.advance !== '') {
      params.advance = payload.event.item.advance
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPost', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  put_items({ commit, dispatch }, payload) {
    let url = 'api/expenses-items-rejected/' + payload.event.itemR.id
    let params = {
      subtotal: payload.event.itemR.subtotal,
      total: payload.event.itemR.total,
      description: payload.event.itemR.description,
      issuer_tax: payload.event.itemR.issuer_tax,
      sat_formaPago_id: payload.event.itemR.sat_formaPago_id,
      uuid: payload.event.itemR.uuid,
      gst_receipt_types_id: payload.event.itemR.gst_receipt_types_id,
      folio: payload.event.itemR.folio,
      sat_metodoPago_id: payload.event.itemR.sat_metodoPago_id,
      validity: payload.event.itemR.validity,
      validity_date: payload.event.itemR.validity_date,
      comment: payload.event.itemR.comment,
      gst_categories_id: payload.event.itemR.gst_categories_id,
      is_refund: payload.event.itemR.is_refund,
      country: payload.event.itemR.country.id,
      currency: payload.event.itemR.currency.id,
      exchange: payload.event.itemR.exchange,
      date: payload.event.itemR.date
    }
    if (payload.event.itemR.fileId) {
      params.file_id = payload.event.itemR.fileId
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('itemsExpensesPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  postExpense({ commit, dispatch }, payload) {
    let url = 'api/expenses'
    let params = {
      user_id: payload.event.user.id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: 1,
      gst_expenses_status_id: 1,
      is_petty_cash: payload.event.item.is_petty_cash
    }
    if (payload.event.item.advance !== '') {
      params.advance = payload.event.item.advance
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPostExpense', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  putExpense({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.item.id
    let params = {
      user_id: payload.event.item.user_id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      description: payload.event.item.description,
      project_id: payload.event.item.project_id,
      status: payload.event.item.status,
      gst_expenses_status_id: payload.event.item.gst_expenses_status_id
    }
    if (payload.event.item.advance !== '') {
      params.advance = payload.event.item.advance
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPutExpense', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  restoreExpense({ commit, dispatch }, payload) {
    let url = 'api/expenses-items-rejected/restore/to-existing-expense'
    let params = {
      gst_expenses_id: payload.event.gst_expenses_id,
      gst_expenses_items_back_ids: payload.event.gst_expenses_items_back_ids
    }
    
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
      
    httpgst.put(url, params, {}).then(
      response => {
        commit('onRestoreExpense', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  redirect_items({ commit, dispatch }, payload) {
    let url = 'api/expenses-items-rejected'
    let params = {
      gst_expenses_id: payload.event.redirect.expenses_id,
      gst_expenses_items_back: payload.event.redirect.items_back_id
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('redirectItems', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  }
}

// mutations
const mutations = {
  itemsGet(state, payload) {
    payload.event.context.itemsBack = payload.response.data.data
    payload.event.context.loadingItems = false
  },
  userLogged(state, payload) {
    payload.event.context.userloggeds = payload.response.data.data
  },
  itemsExpensesPut(state, payload) {
    let itemExpenseId = payload.response.data.data.id
    payload.event.context.loading = false
    payload.event.context.disabled = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.restoreExpenseFromEdit(itemExpenseId)
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onPost(state, payload) {
    payload.event.context.loading = false
    payload.event.context.disabled = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.getExpensesOpen()
    payload.event.context.closeDialogExpense()
  },
  onPostExpense(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.loading = false
    payload.event.context.closeDialog()
    payload.event.context.getExpensesOpen()
  },
  // Updates the data displayed for the modified expense
  onPutExpense(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDialog()
    payload.event.context.getExpensesOpen()
  },
  onRestoreExpense (state, payload) {
    const itemId = payload.event.context.itemsBackIds[0]
    const itemsBack = payload.event.context.itemsBack
    let index = itemsBack.findIndex(function (o) {
      return o.id === itemId
    })
    if (index !== -1) payload.event.context.itemsBack.splice(index, 1)
    payload.event.context.loadingSelectExpenses = false
    payload.event.context.get()
    payload.event.context.closeDialogSelectExpenses()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onGetCategories(state, payload) {
    payload.event.context.categories = payload.response.data.data
  },
  redirectItems(state, payload) {
    payload.event.context.loading = false
    payload.event.context.disabled = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.showMessageAddItem = true
    payload.event.context.closePost()
    payload.event.context.refresh()
  },
  onError(state, payload) {
    payload.event.context.loading = false
    payload.event.context.disabled = false
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.expensesRejected.js